import { gql } from '@apollo/client';
import { CartInfoPublic } from '../fragments';

export default gql`
  query cart($id: ID!, $patientId: ID, $accountId: ID) {
    cart(id: $id, patientId: $patientId, accountId: $accountId) {
      ...CartInfoPublic
    }
  }
  ${CartInfoPublic}
`;
